import { Alert } from "client/CommonComponents";
import "./Information.scss";

interface IProps {
    dismissSuccessAlert?:any,
    successInfoAlert?:any
}
const Information = (props:IProps) => {
    const informationList = [
        {
            text:'Fleet must receive approved transfer request by the 25th of the month for it to reflect on the following months reports.'
        },
        {
            text:'The coordination of relocating the item is the responsibility of the transferring and receiving branches.'
        },
        {
            text:'The assets maintenance folder must be forwarded directly to the receiving branch.'
        }
    ]

    return(<>
        <Alert
            className="alert-message info-successAlert"
            showAlert={props.successInfoAlert}
            dismissAlert={props.dismissSuccessAlert}
            type="success"
            text={<>
            <p className="info-head">Information</p>
            <ul className='information-list'>
            {
                informationList.map((item:any, index:any)=>{
                    return(
                        <li key={index}><span>{item.text}</span></li>
                    )
                })
            }
            </ul>
            </>}
         data-attribute="Information_Default_Alerts" />
       
</>)
}

export default Information;
